import React from 'react';
import lodash from 'lodash';

import { Button, ButtonGroup } from '@mui/material';

interface PaginationProps {
  itemsCount: number;
  pageSize: number;
  currentPage: number;
  onPageChange: (page: number) => void;
}

const Pagination = ({
  itemsCount,
  pageSize,
  currentPage,
  onPageChange,
}: PaginationProps) => {
  const pagesCount = Math.ceil(itemsCount / pageSize);

  if (pagesCount === 1) return null;

  const pages = lodash.range(1, pagesCount + 1);

  return (
    <ButtonGroup sx={{ m: 2 }}>
      {pages.map((page: number) => (
        <Button
          key={page}
          onClick={() => onPageChange(page)}
          variant={page === currentPage ? 'contained' : 'outlined'}
        >
          {page}
        </Button>
      ))}
    </ButtonGroup>
  );
};

export default Pagination;
